export default {
    user: null,
    billingHistory: null,
    defaultImagesList: null,
    paypalToken: null,
    creditCardInfo: null,
    userPlaylists: null,
    userPlaylistsWithVideos: null,
    userSharedPlaylists: null,
    error: {
        show: false,
        message: '',
        originalMessage: ''
    },
    validationStatusError: false,
    corporationPinnedMsgs: null,
    corpUserSharedVideos: null,
    userPlaylistsProfile: null,
    userProgressProfile: null,
    userEmailPreferences: null
}



// WEBPACK FOOTER //
// ./src/store/users/state.js